/**
 * @generated SignedSource<<037566be9abddfae5d58aec84e0b2fc3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
export type AccountEditRoleScreenQuery$variables = {
  id: string;
  storeId?: string | null;
};
export type AccountEditRoleScreenQuery$data = {
  readonly store: {
    readonly storeUser: {
      readonly id: string;
      readonly role: Roles;
    };
  };
};
export type AccountEditRoleScreenQuery = {
  response: AccountEditRoleScreenQuery$data;
  variables: AccountEditRoleScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storeId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "StoreUser",
  "kind": "LinkedField",
  "name": "storeUser",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountEditRoleScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v3/*: any*/),
            "action": "THROW"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountEditRoleScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "76edf211d292d547ba8cf23802296371",
    "id": null,
    "metadata": {},
    "name": "AccountEditRoleScreenQuery",
    "operationKind": "query",
    "text": "query AccountEditRoleScreenQuery(\n  $id: ID!\n  $storeId: ID\n) {\n  store(id: $storeId) {\n    storeUser(id: $id) {\n      id\n      role\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0805e20dafea0cab60d9baa39da9b872";

export default node;
